/* tslint:disable */
/* eslint-disable */
/**
 * external-information-requests
 * Medicaid Pending document requests to family members, with the staff workspace and the family portal
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues, parseDate, parseDateTime, serializeDate, serializeDateTime } from '../runtime';
import type { RequestItemVisibility } from './RequestItemVisibility';
import {
    RequestItemVisibilityFromJSON,
    RequestItemVisibilityFromJSONTyped,
    RequestItemVisibilityToJSON,
    RequestItemVisibilityToJSONTyped,
} from './RequestItemVisibility';

/**
 * 
 * @export
 * @interface RequestItemInput
 */
export interface RequestItemInput {
    /**
     * 
     */
    label: string;
    /**
     * What to send
     */
    instructions?: string | null;
    /**
     * Why it's needed, shown to the family
     */
    participant_reason?: string | null;
    /**
     * 
     */
    item_group?: string | null;
    /**
     * 
     */
    visibility?: RequestItemVisibility;
    /**
     * 
     */
    due_at?: Date | null;
    /**
     * 
     */
    assigned_user_id?: string | null;
    /**
     * 
     */
    sort_order?: number;
}



/**
 * Check if a given object implements the RequestItemInput interface.
 */
export function instanceOfRequestItemInput(value: object): value is RequestItemInput {
    if (!('label' in value) || value['label'] === undefined) return false;
    return true;
}

export function RequestItemInputFromJSON(json: any): RequestItemInput {
    return RequestItemInputFromJSONTyped(json, false);
}

export function RequestItemInputFromJSONTyped(json: any, ignoreDiscriminator: boolean): RequestItemInput {
    if (json == null) {
        return json;
    }
    return {
        
        'label': json['label'],
        'instructions': json['instructions'] === undefined ? undefined : json['instructions'] === null ? null : json['instructions'],
        'participant_reason': json['participant_reason'] === undefined ? undefined : json['participant_reason'] === null ? null : json['participant_reason'],
        'item_group': json['item_group'] === undefined ? undefined : json['item_group'] === null ? null : json['item_group'],
        'visibility': json['visibility'] == null ? undefined : RequestItemVisibilityFromJSON(json['visibility']),
        'due_at': json['due_at'] === undefined ? undefined : json['due_at'] === null ? null : (parseDateTime(json['due_at'])),
        'assigned_user_id': json['assigned_user_id'] === undefined ? undefined : json['assigned_user_id'] === null ? null : json['assigned_user_id'],
        'sort_order': json['sort_order'] == null ? undefined : json['sort_order'],
    };
}

export function RequestItemInputToJSON(json: any): RequestItemInput {
    return RequestItemInputToJSONTyped(json, false);
}

export function RequestItemInputToJSONTyped(value?: RequestItemInput | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'label': value['label'],
        'instructions': value['instructions'],
        'participant_reason': value['participant_reason'],
        'item_group': value['item_group'],
        'visibility': RequestItemVisibilityToJSON(value['visibility']),
        'due_at': value['due_at'] == null ? value['due_at'] : serializeDateTime(value['due_at']),
        'assigned_user_id': value['assigned_user_id'],
        'sort_order': value['sort_order'],
    };
}

